export interface UserRole {
  isAdmin?: boolean;
  isModerator?: boolean;
  isMember: boolean;
}

export enum TeamRole {
  LEADER = "LEADER",
  MEMBER = "MEMBER",
  SUPERVISOR = "SUPERVISOR",
}

export enum Country {
  SRI_LANKA = "SRI_LANKA",
  MALAYSIA = "MALAYSIA",
  BOSNIA = "BOSNIA",
  JAMAICA = "JAMAICA",
  INDIA = "INDIA",
  INDONESIA = "INDONESIA",
}

export enum ApplicationStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

export enum RequestStatus {
  PENDING = "PENDING",
  SCHEDULED = "SCHEDULED",
  REJECTED = "REJECTED",
  DELETED = "DELETED",
  COMPLETED = "COMPLETED",
}

export enum Stage {
  IDEATION = "Ideation",
  BUSINESS_PLAN_FORMULATION = "Idea Validated and Market Analysed",
  IDEA_VALIDATED_AND_MARKET_ANALYZED = "Business Plan Formulation",
  MVP_LAUNCHED = "MVP launched",
  EARLY_REVENUE = "Early Revenue",
  GROWTH_AND_EXPANSION = "Growth and Expansions",
}

export interface CurrentAction {
  isUploading?: boolean;
  isEditing?: boolean;
  allowNavigationAway: boolean;
}

export interface FileContent {
  fileName: string;
  type: string;
  url: string;
}

/**
 * User privileges
 */
 export enum UserPrivilege {
  FORUM = "Forum",
  MENTORS = "Mentors",
  LIBRARY = "Library",
  NOTICES = "Notices",
  TEAM = "Team",
}


/**
 * User action types
 */
 export enum UserActionType {
  CREATE = "CREATE",
  VIEW = "VIEW",
  EDIT = "EDIT",
  DELETE = "DELETE",
  OPERATE = "OPERATE",
}

/**
 * Public team constants.
 */
export enum PublicTeam {
  PUBLIC_TEAM = "PUBLIC-TEAM",
  PUBLIC_PROJECT = "PUBLIC-PROJECT"
}
